/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2021-11-11 13:29:34
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-04-22 10:30:41
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/lang/index.js
 * @Description:
 * Copyright (c) 2024 by WeMeet, All Rights Reserved.
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
import { getCookie } from "@/utils/cookieinfo.js";

Vue.use(VueI18n);

let locale = localStorage.getItem("lang") || "CN";
const i18n = new VueI18n({
  locale: "CN",
  messages: {
    CN: require("./zh"),
    EN: require("./en"),
    AR: require("./ar"),
    DE: require("./de"),
    RU: require("./ru"),
    FR: require("./fr"),
    KO: require("./ko"),
    MS: require("./ms"),
    PT: require("./pt"),
    JA: require("./ja"),
    TH: require("./th"),
    TR: require("./tr"),
    ES: require("./es"),
    IT: require("./it"),
    ID: require("./id"),
    VI: require("./vi"),
  },
});

export default i18n;
